import { Component, OnInit } from "@angular/core";
import { formatDate } from "@angular/common";
import * as moment from "moment";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
} from "@angular/forms";
import { AwsService } from "../../../providers/appsyncservice/aws.service";
import { UserTypePipePipe } from "../../../pipes/user-type-pipe.pipe";
import { positions } from "../../../models/positions";
declare var google: any;
import * as XLSX from "xlsx";
import * as jsPDF from "jspdf";
import { json } from "body-parser";
import { UserDetailsService } from "../../../service/userdetails/user-details.service";
import {
  RequestType,
  CapSMSMailService,
} from "../../../service/capsmsmail/cap-smsmail.service";
import { AppConstants } from "../../../constants/app-constants";
import { DateutilService } from "./../../../service/dateutil/dateutil.service";
import { AwsAppServiceProvider } from "../../../providers/appsyncservice/ca.aws.notification.services";

export interface pushNotification {
  token?: string;
  notification?: {
    title?: string;
    body?: string;
  };
  android: {
    notification: {
      click_action: string;
    };
  };
  apns: {
    headers: {
      "apns-priority": string;
    };
    payload: {
      aps: {
        category: string;
      };
    };
  };
  data?: {
    icon: string;
    navigationTo: string;
    content: string;
    cp_header: string;
    request_id?: string;
  };
}

@Component({
  selector: "app-house-relocation",
  templateUrl: "./house-relocation.component.html",
  styleUrls: ["./house-relocation.component.css"],
})
export class HouseRelocationComponent implements OnInit {
  displayValue: Number = 0;
  houseloc_list: any = [];
  house_info: any = [];
  vendorDateTime: any = [];
  vendor_datalist: any = [];
  houseRelocationBox: any = [];
  houseReFeedBackBox: any = [];
  submitted = false;
  mode = false;
  statusComp: any;
  houseReLocationFm: FormGroup;
  statusFilterFm: FormGroup;
  rowID: any;
  activeVendorId: any;
  comments: any = [];
  userInfo: any = [];
  status: any = [
    { id: 2, name: "ACKNOWLEDGED" },
    { id: 3, name: "REJECTED" },
    { id: 4, name: "IN_PROGRESS" },
    { id: 5, name: "COMPLETED" },
  ];
  editDataView: any = {};

  sortKey: string = "sno"; //set default
  sortReverse: boolean = false;
  noOfItems = 10;

  that: any;

  setDateToGo: number;
  minDate: any;

  snoFilterModel: any = new Array();
  createdTypeFilterModel: any = new Array();
  TicketIdFilterModel: any = new Array();
  usernameFilterModel: any = new Array();
  nameFilterModel: any = new Array();
  houseAddressFilterModel: any = new Array();
  requestStatusFilterModel: any = new Array();
  requestIdFilterModel: any = new Array();
  ageFilterModel: any = new Array();
  slaTimingFilterModel: any = new Array();
  createdDateFilterModel: any = new Array();

  snoFilterData: any = [];
  createdTypeFilterData: any = [];
  TicketIdFilterData: any = [];
  usernameFilterData: any = [];
  nameFilterData: any[];
  houseAddressFilterData: any[];
  requestStatusFilterData: any[];
  requestIdFilterData: any[];
  slaTimingFilterData: any[];
  ageIdFilterData: any[];
  createdDateFilterData: any[];

  dropdownSettings = {
    sno: {
      singleSelection: false,
      idField: "sno",
      enableCheckAll: true,
      itemsShowLimit: 2,
      allowSearchFilter: true,
      searchPlaceholderText: "Search S.No.",
    },
    createType: {
      singleSelection: false,
      idField: "createType",
      enableCheckAll: true,
      itemsShowLimit: 2,
      allowSearchFilter: true,
      searchPlaceholderText: "Search createType.",
    },
    ticketId: {
      singleSelection: false,
      idField: "ticketId",
      enableCheckAll: true,
      itemsShowLimit: 2,
      allowSearchFilter: true,
      searchPlaceholderText: "Search ticket id.",
    },
    username: {
      singleSelection: false,
      idField: "username",
      enableCheckAll: true,
      itemsShowLimit: 1,
      allowSearchFilter: true,
      searchPlaceholderText: "Search RN No.",
    },
    name: {
      singleSelection: false,
      idField: "name",
      enableCheckAll: true,
      itemsShowLimit: 1,
      allowSearchFilter: true,
      closeDropDownOnSelection: true,
      searchPlaceholderText: "Search Name",
    },
    house_address: {
      singleSelection: false,
      idField: "house_address",
      enableCheckAll: true,
      itemsShowLimit: 1,
      allowSearchFilter: true,
      closeDropDownOnSelection: true,
      searchPlaceholderText: "Search Address",
    },
    request_id: {
      singleSelection: false,
      idField: "request_id",
      enableCheckAll: true,
      itemsShowLimit: 1,
      allowSearchFilter: true,
      searchPlaceholderText: "Search Request ID",
    },
    request_status: {
      singleSelection: false,
      idField: "request_status",
      enableCheckAll: true,
      itemsShowLimit: 1,
      allowSearchFilter: true,
      searchPlaceholderText: "Search Request Status",
    },
    sla_timing: {
      singleSelection: false,
      idField: "sla_timing",
      enableCheckAll: true,
      itemsShowLimit: 1,
      allowSearchFilter: true,
      searchPlaceholderText: "Search SLA",
    },
    age: {
      singleSelection: false,
      idField: "age",
      enableCheckAll: true,
      itemsShowLimit: 1,
      allowSearchFilter: true,
      searchPlaceholderText: "Search age",
    },
    created_date: {
      singleSelection: false,
      idField: "created_date",
      enableCheckAll: true,
      itemsShowLimit: 1,
      allowSearchFilter: true,
      searchPlaceholderText: "Search Date",
    },
  };

  slaNextWorkingDay: any;

  constructor(
    public awserviceProvider: AwsService,
    private formBuilder: FormBuilder,
    private userDetailservice: UserDetailsService,
    private capSmsMail: CapSMSMailService,
    private dateUtil: DateutilService,
    private pushNotificationService: AwsAppServiceProvider
  ) {
    this.that = this;
    this.getAllData();
    this.selectDateMinTime();
  }

  // GET DATA
  getAllData() {
    this.houseloc_list = [];
    console.log("House Relocation data getAllData");
    this.awserviceProvider.getHouseReLocationListAll().then((data) => {
      this.constructData(data);
      console.log("response", data);
    });
  }
  selectDateMinTime() {
    var todayDate = new Date();
    var month =
      (todayDate.getMonth() + 1 < 10 ? "0" : "") + (todayDate.getMonth() + 1);
    var day = (todayDate.getDate() < 10 ? "0" : "") + todayDate.getDate();
    var year = todayDate.getFullYear();
    this.minDate = year + "-" + month + "-" + day;
  }
  async constructData(data) {
    this.houseloc_list = [];
    var oplist = [];
    for (var i in data) {
      data[i].created_type = data[i].created_type;
      data[i].ticket_id = data[i].ticket_id;
      var rsdata = data[i];
      data[i].sno = +i + 1;

      if (
        data[i].request_status == "CANCELLED" ||
        data[i].request_status == "REJECTED" ||
        data[i].request_status == "COMPLETED"
      ) {
        var f = moment(data[i].created_date);
        var s = moment(data[i].comments[data[i].comments.length - 1].date);
        data[i].age = f.from(s, true);
        data[i].ageSort = f.diff(s, "seconds");
      } else {
        data[i].age = moment(data[i].created_date).fromNow(false);
        data[i].ageSort = moment().diff(
          moment(data[i].created_date),
          "seconds"
        );
      }

      var name;
      if (rsdata.user_display_name == undefined) {
        var val = await this.userDetailservice.getDetails(rsdata.username);
        name = val.name;
      } else {
        name = rsdata.user_display_name;
      }
      data[i].house_address =
        rsdata.house_address == undefined ? "-" : rsdata.house_address;
      data[i].name = name;
      data[i].request_statusSort =
        AppConstants.REQUEST_STATUS[data[i].request_status];
      data[i].request_statusColor =
        data[i].request_status == "NEW_REQUEST"
          ? AppConstants.StatusColor.ORANGE
          : data[i].request_status == "ACKNOWLEDGED" ||
            data[i].request_status == "IN_PROGRESS"
            ? AppConstants.StatusColor.GREEN
            : "";

      data[i].sla_timing = "-";
      data[i].sla_timing_color = "";

      if (data[i].request_status == "NEW_REQUEST") {
        var newReq = this.dateUtil.getNumberOfWorkingDays(
          new Date(),
          new Date(data[i].created_date)
        );
        console.log(
          "newReq",
          newReq,
          newReq < -1,
          new Date(),
          new Date(data[i].created_date)
        );
        if (newReq < -1) {
          data[i].sla_timing = newReq * -1 + " working days is elapsed";
          data[i].sla_timing_color = AppConstants.StatusCssClass.ELAPSED;
          data[i].request_statusSort = newReq;
        } else {
          data[i].sla_timing = "1 working day is remaining";
        }
      } else if (
        data[i].request_status == "ACKNOWLEDGED" ||
        data[i].request_status == "IN_PROGRESS"
      ) {
        if (data[i].sla_date != null) {
          var ackInpro = this.dateUtil.getNumberOfWorkingDays(
            new Date(),
            new Date(data[i].sla_date)
          );
          console.log("ackInpro", ackInpro);
          if (ackInpro > 0)
            data[i].sla_timing = ackInpro + " working days is remaining";
          if (ackInpro < 0) {
            data[i].sla_timing = ackInpro * -1 + " working days is elapsed";
            data[i].sla_timing_color = AppConstants.StatusCssClass.ELAPSED;
            data[i].request_statusSort = ackInpro;
          }
        }
      }

      oplist.push(data[i]);
    }
    oplist = oplist.sort((a, b) => {
      if (a.request_statusSort < b.request_statusSort) {
        return -1;
      } else if (a.request_statusSort > b.request_statusSort) {
        return 1;
      } else if (a.request_statusSort == b.request_statusSort) {
        var adate = new Date(a.created_date);
        var bdate = new Date(b.created_date);
        if (a.sla_timing == "-" && b.sla_timing == "-") {
          if (adate.getTime() > bdate.getTime()) {
            return -1;
          } else if (adate.getTime() < bdate.getTime()) {
            return 1;
          }
        } else {
          if (adate.getTime() > bdate.getTime()) {
            return 1;
          } else if (adate.getTime() < bdate.getTime()) {
            return -1;
          }
        }
        return 0;
      }

      return 0;
    });
    oplist = this.addSno(oplist);
    this.houseloc_list = oplist;
  }
  private addSno(list: any[]): any[] {
    var ls: any[] = [];
    for (var rs in list) {
      var rsdata = list[rs];
      ls[rs] = rsdata;
      ls[rs].sno = +rs + 1;
    }
    return ls;
  }

  filterSearch(th, items, filter) {
    let result = items.filter((val) => {
      if (
        filter.sno.length == 0 &&
        filter.username.length == 0 &&
        filter.house_address.length == 0 &&
        filter.name.length == 0 &&
        filter.request_id.length == 0 &&
        filter.request_status.length == 0 &&
        filter.sla_timing.length == 0 &&
        filter.age.length == 0 &&
        filter.created_date.length == 0
      ) {
        return true;
      } else {
        // if(filter.sno.indexOf(""+val.sno)>=0 && filter.username.indexOf(val.username)>=0 && filter.name.indexOf(val.name)>=0 && concernFound.length>0 && filter.request_id.indexOf(val.request_id)>=0 && filter.request_status.indexOf(val.request_status)>=0 && filter.created_date.indexOf(formatDate(val.created_date,'MMM dd, yyyy','en'))>=0)
        return (
          (filter.sno.length > 0
            ? filter.sno.indexOf("" + val.sno) >= 0
            : true) &&
          (filter.username.length > 0
            ? filter.username.indexOf(val.username) >= 0
            : true) &&
          (filter.name.length > 0
            ? filter.name.indexOf(val.name) >= 0
            : true) &&
          (filter.house_address.length > 0
            ? filter.house_address.indexOf(val.house_address) >= 0
            : true) &&
          (filter.request_id.length > 0
            ? filter.request_id.indexOf(val.request_id) >= 0
            : true) &&
          (filter.age.length > 0 ? filter.age.indexOf(val.age) >= 0 : true) &&
          (filter.request_status.length > 0
            ? filter.request_status.indexOf(val.request_status) >= 0
            : true) &&
          (filter.sla_timing.length > 0
            ? filter.sla_timing.indexOf(val.sla_timing) >= 0
            : true) &&
          (filter.created_date.length > 0
            ? filter.created_date.indexOf(
              formatDate(val.created_date, "MMM dd, yyyy", "en")
            ) >= 0
            : true)
        );
      }
    });

    th.constructDropDownData(th, result, false);

    return result;
  }

  constructDropDownData(th, items, isData) {
    //  console.log("constructDropDownData",th.usernameFilterData);
    var snoData = [];
    var createdTypeData = [];
    var ticketIdData = [];
    var usernameData = [];
    var nameData = [];
    var houseAddressData = [];
    var requestIdData = [];
    var requestStatusData = [];
    var slaTimingData = [];
    var ageData = [];
    var createdDateData = [];

    for (var item of items) {
      console.log("username", item.sno, snoData.indexOf(item.sno));
      if (snoData.indexOf(item.sno) == -1) snoData.push("" + item.sno);
      if (createdTypeData.indexOf(item.created_type) == -1)
        createdTypeData.push("" + item.created_type);
      if (ticketIdData.indexOf(item.ticket_id) == -1)
        ticketIdData.push("" + item.ticket_id);
      if (usernameData.indexOf(item.username) == -1)
        usernameData.push(item.username);
      if (nameData.indexOf(item.name) == -1) nameData.push(item.name);
      if (houseAddressData.indexOf(item.house_address) == -1)
        houseAddressData.push(item.house_address);
      if (requestIdData.indexOf(item.request_id) == -1)
        requestIdData.push(item.request_id);
      if (requestStatusData.indexOf(item.request_status) == -1)
        requestStatusData.push(item.request_status);
      if (slaTimingData.indexOf(item.sla_timing) == -1)
        slaTimingData.push(item.sla_timing);
      if (ageData.indexOf(item.age) == -1) ageData.push(item.age);
      if (
        createdDateData.indexOf(
          formatDate(item.created_date, "MMM dd, yyyy", "en")
        ) == -1
      )
        createdDateData.push(
          formatDate(item.created_date, "MMM dd, yyyy", "en")
        );
    }

    console.log("constructDropDownData-", usernameData);
    if (isData) {
      th.snoFilterData = snoData;
      th.createTypeFilterData = createdTypeData;
      th.TicketIdFilterData = ticketIdData;
      th.usernameFilterData = usernameData;
      th.nameFilterData = nameData;
      th.houseAddressFilterData = houseAddressData;
      th.requestIdFilterData = requestIdData;
      th.requestStatusFilterData = requestStatusData;
      th.slaTimingFilterData = slaTimingData;
      th.ageIdFilterData = ageData;
      th.createdDateFilterData = createdDateData;
    } else {
      setTimeout(() => {
        /*   th.snoFilterModel=snoData
       th.usernameFilterModel=usernameData;
        th.nameFilterModel=nameData;
        th.concenTypeFilterModel=concenTypeData.filter((item,index) => concenTypeData.indexOf(item) === index)
        th.requestIdFilterModel=requestIdData
        th.requestStatusFilterModel=requestStatusData
        th.createdDateFilterModel=createdDateData */

        th.snoFilterData = snoData;
        th.createTypeFilterData = createdTypeData;
        th.TicketIdFilterData = ticketIdData;
        th.usernameFilterData = usernameData;
        th.nameFilterData = nameData;
        th.houseAddressFilterData = houseAddressData;
        th.requestIdFilterData = requestIdData;
        th.requestStatusFilterData = requestStatusData;
        th.slaTimingFilterData = slaTimingData;
        th.ageIdFilterData = ageData;
        th.createdDateFilterData = createdDateData;
      }, 0);
    }
  }

  // GET VENDOR DATA
  getVendorAllData() {
    console.log("Vendor data getVendorAllData");
    this.awserviceProvider.getVendorlist().then((data) => {
      // this.vendor_datalist = data;
      console.log("data", data);
      this.vendor_datalist = data.filter(
        (res) => res.vendor_type === "Relocation"
      );
      console.log("response", data);
    });
  }

  async openStatus(houseLocation) {
    console.log("openstatus", houseLocation);
    // console.log("this.displayValue", this.displayValue);
    this.houseRelocationBox = houseLocation.comments;
  }

  vendorInformation(vendor_details) {
    // console.log("item", item.vendor_id);
    console.log("index", vendor_details);
    var vm = this;

    // return vm.awserviceProvider.vendorIdFilter(vendor_details);
    const test = vm.awserviceProvider.vendorIdFilter(vendor_details);
    return test;
    // .then(result => {
    //   console.log("Vendor details", result);
    // })
    // .catch(err => {
    //   console.log("err", err);
    // });
  }

  openFeedBackStatus(value) {
    console.log("feedback", value.feedback);
    console.log("status", value.satisfaction);
    this.houseReFeedBackBox = [];
    this.houseReFeedBackBox.push(value);
    console.log("this.houseReFeedBackBox", this.houseReFeedBackBox);
  }

  formInitilization() {
    this.houseReLocationFm = this.formBuilder.group({
      id: [""],
      comments_des: ["", Validators.required],
      comments_status: ["", [Validators.required, Validators.min(1)]],
      // vendor_dt: ["", [Validators.required, Validators.min(1)]]
      vendor_dt: [""],
      sl_date: [{ value: "", disabled: true }],
    });
  }

  get f() {
    return this.houseReLocationFm.controls;
  }

  //  EDIT DATA
  async editData(houseLocation) {
    this.editDataView = houseLocation;
    console.log("editData", houseLocation);
    this.singleHouseRelocationData(houseLocation.id);
    console.log(
      "test==================",
      this.houseReLocationFm.value.vendor_dt
    );
    this.displayValue = 1;
    this.formInitilization();
    this.rowID = houseLocation.id;
    this.comments = houseLocation.comments;
    this.userInfo = [];
    this.vendorDateTime = [];
    for (let i = 0; i < houseLocation.vendor_details.length; i++) {
      const numFruit = await this.vendorInformation(
        houseLocation.vendor_details[i].vendor_id
      );
      numFruit[0].slot1 = houseLocation.vendor_details[i].date;
      numFruit[0].slot2 = houseLocation.vendor_details[i].ex_data;
      this.vendorDateTime.push(numFruit[0]);
      console.log(numFruit);
      console.log("this.vendorDateTime", this.vendorDateTime);
    }
    this.userInfo = [houseLocation];
    this.activeVendorId = this.userInfo[0].packing_Date[0].vendor_id;
    this.userHouseDetails(houseLocation.house_id);
    console.log(
      "TCL: HouseRelocationComponent -> editData ->  this.userInfo",
      this.userInfo
    );
    this.mode = true;
    this.slaNextWorkingDay = "";
  }

  singleHouseRelocationData(id) {
    // 1187 , 2556
    this.awserviceProvider
      .singleHouseRelocationData(id)
      .then((result) => {
        console.log("xxxxxxxxx", result);
        this.statusComp = result[0].ex_data;
        console.log("this.statusComp", this.statusComp);
      })
      .catch((err) => {
        console.log("err", err);
      });
  }

  // House Details
  userHouseDetails(hid) {
    this.awserviceProvider
      .userHouseFilter(hid)
      .then((result) => {
        console.log("user house details", result);
        this.house_info = result;
      })
      .catch((err) => {
        console.log("err", err);
      });
  }

  // SAVE DATA
  onSubmit() {
    console.log("Add - car data", this.houseReLocationFm.value);
    if (this.houseReLocationFm.value.comments_status === "COMPLETED") {
      this.houseReLocationFm.controls["vendor_dt"].setValidators([
        Validators.required,
      ]);
      this.houseReLocationFm.controls["vendor_dt"].updateValueAndValidity();
    }
    this.submitted = true;
    if (this.houseReLocationFm.invalid) {
      return;
    }
    var day = "";
    var sla = "0";
    switch (this.houseReLocationFm.value.comments_status) {
      case "NEW_REQUEST":
        day = "INPRO";
        break;
      case "ACKNOWLEDGED":
        day = "INPRO";
        sla = AppConstants.REQUEST_SLA.HOUSE_RELOCATION;
        break;
      case "IN_PROGRESS":
        day = "INPRO";
        break;
      case "REJECTED":
        day = "INPRO";
        break;
      case "BLOCKED":
        day = "INPRO";
        break;
      case "CANCELLED":
        day = "INPRO";
        break;
      case "COMPLETED":
        day = "INPRO";
        break;
    }

    var d = new Date();
    var mm = Number(d.getMonth() + 1);
    var dateValue = d.getFullYear() + "-" + mm + "-" + d.getDate();
    var test1 = {
      date: dateValue,
      des: this.houseReLocationFm.value.comments_des,
      status: this.houseReLocationFm.value.comments_status,
      exdata: sla,
    };


    console.log("this.userInfo", this.userInfo);
    var vendordata = {
      date: this.userInfo[0].packing_Date[0].date,
      ex_data: this.userInfo[0].packing_Date[0].ex_data,
      id: this.userInfo[0].packing_Date[0].id,
      vendor_id:
        this.houseReLocationFm.value.comments_status === "COMPLETED" &&
          this.houseReLocationFm.value.vendor_dt !== ""
          ? this.houseReLocationFm.value.vendor_dt
          : "0",
      // vendor_id:
      //   this.houseReLocationFm.value.vendor_dt === ""
      //     ? "0"
      //     : this.houseReLocationFm.value.vendor_dt
    };
    var houseReLocData = {
      id: this.rowID,
      comments: this.comments.length === 0 ? [test1] : [...this.comments, test1],
      request_status: this.houseReLocationFm.value.comments_status,
      ex_data: day,
      sla_date:
        this.slaNextWorkingDay == ""
          ? this.editDataView.sla_date
          : this.slaNextWorkingDay,
      packing_Date: [vendordata],
    };
    const pushNotificationConfirmObject = {
      comments: this.houseReLocationFm.value.comments_des,
      status: this.houseReLocationFm.value.comments_status,
    };
    console.log("this.comments", houseReLocData);
    this.awserviceProvider
      .UpdateReHouseRequestData(houseReLocData)
      .then((result) => {
        this.rowID = "";
        this.comments = "";
        this.getAllData();
        this.displayValue = 0;

        this.capSmsMail.sendMailandSMS(result, RequestType.HOUSE_RELOCATION);

        this.constructPushNotification(result, pushNotificationConfirmObject);
        
      })
      .catch((err) => {
        console.log("err", err);
      });
  }

  backbtn() {
    this.displayValue = 0;
  }

  ngOnInit() {
    this.displayValue = 0;
    this.formInitilization();
    console.log("car data module init");
  }

  public sort(sortKey) {
    this.sortKey = sortKey;
    this.sortReverse = !this.sortReverse;
  }

  public sortClass(sortKey) {
    if (this.sortKey == sortKey) {
      if (this.sortReverse) {
        return "fa fa-sort-desc";
      } else {
        return "fa fa-sort-asc";
      }
    } else {
      return "fa fa-sort";
    }
  }

  exportToExcel() {
    let exportJsonTemp = [];

    exportJsonTemp = this.excelDataFormation(this.houseloc_list);
    const workBook = XLSX.utils.book_new(); // create a new blank book

    const workSheet = XLSX.utils.json_to_sheet(exportJsonTemp);

    // ////console.log("EXCEL", exportJsonTemp);
    XLSX.utils.book_append_sheet(workBook, workSheet, "Data"); // add the worksheet to the book

    XLSX.writeFile(
      workBook,
      "House Relocation Request-" + new Date().getTime() + ".xlsx"
    );
  }

  excelDataFormation(list) {
    let dateFormat = require("dateformat");
    var otlist = [];
    for (var l of list) {
      var r = {
        Sno: l.sno,
        "Request ID": l.request_id,
        "Request Status": l.request_status,
        "Ticket Age": l.age,
        "User name": l.username,
        Name: l.name,
        "House Address": l.house_address,
        Types: l.user_request,
        Description: l.user_text,
        SLA: l.sla_timing,
        "Feedback Status": l.satisfaction == 0 ? "" : l.satisfaction,
        "Feedback Description": l.feedback == 0 ? "" : l.feedback,
        "Request Date": dateFormat(l.created_date, "yyyy-mm-dd HH:MM:ss"),
        "Updated Date": dateFormat(l.updated_date, "yyyy-mm-dd HH:MM:ss"),
      };

      otlist.push(r);
    }
    return otlist;
  }

  valuechange(paramDate: any) {
    console.log("SELECTED-DATE", paramDate);
    let date_1 = new Date(paramDate);
    let date_2 = new Date();

    const days = (date_1, date_2) => {
      let difference = date_1.getTime() - date_2.getTime();
      let TotalDays = Math.ceil(difference / (1000 * 3600 * 24));
      return TotalDays;
    };

    this.setDateToGo = days(date_1, date_2);
    // var day = new Date();
    // day = new Date(formatDate(day, "yyyy-MM-dd", "en"));
    // if (date.getDay() === 0 || date.getDay() === 6) {

    // }

    var day = new Date(paramDate).getUTCDay();
    if ([6, 0].includes(day)) {
      this.houseReLocationFm.controls.sl_date.setErrors({
        invalidNumber: true,
      });
    } else {
      this.houseReLocationFm.controls.sl_date.setErrors(null);
      this.slaNextWorkingDay = paramDate; //this.dateUtil.getNextWorkingDayFrom(paramDate);
    }

    // this.slaNextWorkingDay = this.dateUtil.getNextWorkingDayFrom(
    //   this.setDateToGo
    // );
    console.log(this.setDateToGo + " days to");
  }

  onStatusChange() {
    if (this.houseReLocationFm.value.comments_status == "ACKNOWLEDGED") {
      this.slaNextWorkingDay = this.dateUtil.getNextWorkingDayFrom(
        this.setDateToGo
      );
      this.houseReLocationFm.get("sl_date").enable();
    } else {
      this.houseReLocationFm.get("sl_date").disable();
    }
    {
    }
  }
  // onStatusChange() {
  //   console.log("onStatusChange", this.houseReLocationFm.value.comments_status);
  //   if (this.houseReLocationFm.value.comments_status == "ACKNOWLEDGED") {
  //     this.slaNextWorkingDay = this.dateUtil.getNextWorkingDayFrom(30);
  //   }
  // }

  constructPushNotification(param, bodyMsg) {
    console.log("::param", param.username);
    var rn = "RN55555";
    // Notification Title
    // Notification Content
    // Notification URL
    // Notification Icon
    // Browser Icon
    // Notification image

    this.pushNotificationService.listApplicationServices(param.username).then(
      (items) => {
        console.log("APP-SERVICE-LIST-SUCCESS", items);
        var status = param.request_status.toUpperCase().replace(/[_-]/g, " ");
        var pushObj: pushNotification = {
          token: items.fcm_token,
          notification: {
            title: "RNConnect - Cap Assits ",
            body:
              `House relocation - Your request id  ${param.request_id} ` +
              " status is " +
              status,
          },
          android: {
            notification: {
              click_action: "FCM_PLUGIN_ACTIVITY",
            },
          },
          apns: {
            headers: {
              "apns-priority": "5",
            },
            payload: {
              aps: {
                category: "NEW_MESSAGE_CATEGORY",
              },
            },
          },
          data: {
            icon: "ic_launcher",
            navigationTo: "ca-notification",
            content: bodyMsg.comments,
            cp_header: "houseRelocation",
            request_id: param.request_id
          },
        };
        this.capSmsMail.pushNotificationFCM(pushObj);
      },
      (error) => {
        // Some task on failure
        console.log("APP-SERVICE-LIST-ERROR", error);
      }
    );
  }
}
